import { Box } from '@mui/material';
import { UBWebMobile } from './UBWebMobileMock';
import { DataGrid } from '@mui/x-data-grid';
import { UBMetric } from "./UBMetricMock";

const columns = [
    { field: 'channel', headerName: 'Channel', width: 130},
    { field: 'activate_card_one', headerName: 'Activate Card', width: 130 , type: "number"},
    { field: 'activate_card_two', headerName: 'Activate Card', width: 130 , type: "number"},
    { field: 'activate_card_three', headerName: 'Activate Card', width: 130 , type: "number"},
    { field: 'paperless_one', headerName: 'Paperless', width: 130 , type: "number"},
    { field: 'paperless_two', headerName: 'Paperless', width: 130 , type: "number"},
    { field: 'paperless_three', headerName: 'Paperless', width: 130 , type: "number"},
    { field: 'alert_visitor', headerName: 'Alert Visitor', width: 130 , type: "number"},
    { field: 'alert_enrollment', headerName: 'Alert Enrollment', width: 130 , type: "number"},
    { field: 'alert_skip', headerName: 'Alert Skip', width: 130 , type: "number"},
    { field: 'digital_wallet_one', headerName: 'Digital Wallet', width: 130 , type: "number"},
    { field: 'digital_wallet_two', headerName: 'Digital Wallet', width: 130 , type: "number"},
    { field: 'digital_wallet_three', headerName: 'Digital Wallet', width: 130 , type: "number"},
    { field: 'auto_pay_load', headerName: 'Auto Pay Loan', width: 130 , type: "number"},
    { field: 'auto_pay_enrollment', headerName: 'Auto Pay Enrollment', width: 130 , type: "number"},
    { field: 'aau_landing', headerName: 'AAU Landing', width: 130 , type: "number"},
    { field: 'aau_success', headerName: 'AAU Success', width: 130 , type: "number"},
    { field: 'aau_skip', headerName: 'AAU Skip', width: 130 , type: "number"},
];

const rows = [
    {
        id: 1,
        channel: "Mobile Web",
        activate_card_one: 0,
        activate_card_two: 0,
        activate_card_three: 0,
        paperless_one: 0,
        paperless_two: 0,
        paperless_three: 0,
        alert_visitor: 0,
        alert_enrollment: 0,
        alert_skip: 0,
        digital_wallet_one: 0,
        digital_wallet_two: 0,
        digital_wallet_three: 0,
        auto_pay_load: 0,
        auto_pay_enrollment: 0,
        aau_landing: 0,
        aau_success: 0,
        aau_skip: 0,
    },
    {
        id: 2,
        channel: "OLB",
        activate_card_one: 30,
        activate_card_two: 23,
        activate_card_three: 4,
        paperless_one: 13,
        paperless_two: 12,
        paperless_three: 2,
        alert_visitor: 7,
        alert_enrollment: 5,
        alert_skip: 0,
        digital_wallet_one: 0,
        digital_wallet_two: 0,
        digital_wallet_three: 0,
        auto_pay_load: 34,
        auto_pay_enrollment: 3,
        aau_landing: 49,
        aau_success: 6,
        aau_skip: 5,
    },
    {
        id: 3,
        channel: "USBAPP",
        activate_card_one: 115,
        activate_card_two: 100,
        activate_card_three: 2,
        paperless_one: 55,
        paperless_two: 47,
        paperless_three: 0,
        alert_visitor: 46,
        alert_enrollment: 42,
        alert_skip: 1,
        digital_wallet_one: 48,
        digital_wallet_two: 28,
        digital_wallet_three: 10,
        auto_pay_load: 166,
        auto_pay_enrollment: 40,
        aau_landing: 145,
        aau_success: 11,
        aau_skip: 36,
    }
  ];

export const UBDashboardMock = () => {
    return (
        <Box
            container
            minHeight="95vh"
            height="100%"
            sx={{
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateColumns: 'repeat(8, 1fr)',
                gap: 1,
                p: 1,
            }}
        >

            <Box sx={{ gridRow: { xs: "1", sm: "1", md: "1", lg: "1" }, gridColumn: { xs: "span 8", sm: "span 8", md: "1 / 5", lg: "1 / 3"} }}>
                <UBMetric title="Enrollment" events={[
                    { event_label: "Fast Track", metrics: [{ label: "Web", value: 135 }, { label: "Mobile", value: 230 }] },
                    { event_label: "Call to Action", metrics: [{ label: "Web", value: 80 }, { label: "Mobile", value: 195 }] },
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "2", sm: "2", md: "2", lg: "2" }, gridColumn: { xs: "span 8", sm: "span 8", md: "1 / 5", lg: "1 / 3"} }}>
                <UBMetric title="Login & Login Assistance" events={[
                    { event_label: "Login", metrics: [{ label: "Web", value: 200 }, { label: "Mobile", value: 280 }] },
                    { event_label: "Login Assistance", metrics: [{ label: "Web", value: 30 }, { label: "Mobile", value: 80 }] },
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "3", sm: "3", md: "3", lg: "3" }, gridColumn: { xs: "span 8", sm: "span 8", md: "1 / 5", lg: "1 / 3"} }}>
                <UBMetric title="Customer / Account" events={[
                    { event_label: "Customer Dashboard", metrics: [{ label: "Web", value: 200 }, { label: "Mobile", value: 280 }] },
                    { event_label: "Account Dashboard", metrics: [{ label: "Web", value: 170 }, { label: "Mobile", value: 230 }] },
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "4", sm: "4", md: "1 / 4", lg: "1 / 4"}, gridColumn: { xs: "span 8", sm: "span 8", md: "5 / 9", lg: "3 / 5"} }}>
                <UBWebMobile title="Fast Track Enrollment Flow" events={[
                    { event_label: "Handshake from UB (token creation)", web: 150, mobile: 250 },
                    { event_label: "Identify Customer", web: 145, mobile: 245 },
                    { event_label: "OTP Success", web: 145, mobile: 245 },
                    { event_label: "Account Creation", web: 143, mobile: 245 },
                    { event_label: "Login Clicked", web: 141, mobile: 245 },
                    { event_label: "Customer Dashboard Landing", web: 135, mobile: 230 },
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "5", sm: "5", md: "4 / 7", lg: "1 / 4"}, gridColumn: { xs: "span 8", sm: "span 8", md: "1 / 5", lg: "5 / 7"} }}>
                <UBWebMobile title="Call to Action Enrollment" events={[
                    { event_label: "Identify Customer", web: 100, mobile: 220 },
                    { event_label: "OTP Success", web: 90, mobile: 210 },
                    { event_label: "Account Creation", web: 90, mobile: 210 },
                    { event_label: "Login Clicked", web: 80, mobile: 200 },
                    { event_label: "Customer Dashboard Landing", web: 80, mobile: 195 },
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "6", sm: "6", md: "4", lg: "1" }, gridColumn: { xs: "span 8", sm: "span 8", md: "5 / 9", lg: "7 / 9"} }}>
                <UBMetric title="Bill Pay" compact events={[
                    { metrics: [{ label: "Web", value: 20 }, { label: "Mobile", value: 30 }] },
                ]} />
            </Box>
                
            <Box sx={{ gridRow: { xs: "7", sm: "7", md: "5", lg: "2" }, gridColumn: { xs: "span 8", sm: "span 8", md: "5 / 9", lg: "7 / 9"} }}>
                <UBMetric title="Transfers" events={[
                    { event_label: "Internal Transfers", metrics: [{ label: "Attempts", value: 80 }, { label: "Successful", value: 75 }] },
                    { event_label: "External Transfers", metrics: [{ label: "Attempts", value: 40 }, { label: "Successful", value: 45 }] },
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "8", sm: "8", md: "6", lg: "3" }, gridColumn: { xs: "span 8", sm: "span 8", md: "5 / 7", lg: "7"} }}>
                <UBMetric title="Zelle" events={[
                    { event_label: "", metrics: [{ label: "Registration", value: 20 }, { label: "Sent", value: 30 }, { label: "Received", value: 30 }]}
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "9", sm: "9", md: "6", lg: "3" }, gridColumn: { xs: "span 8", sm: "span 8", md: "7 / 9", lg: "8"} }}>
                <UBMetric title="MCD" events={[
                    { event_label: "", metrics: [{ label: "Attempts", value: 40 }, { label: "Successful", value: 40 }]}
                ]} />
            </Box>

            <Box sx={{ gridRow: { xs: "10", sm: "10", md: "7", lg: "4"}, gridColumn: "span 8" }}>
                {/* <Typography variant="h5" fontWeight="bold" align="left">Onboarding</Typography>

                <Divider /> */}

                <DataGrid
                    title="test"
                    rows={rows}
                    columns={columns}
                    hideFooter
                    autoHeight
                />
            </Box>
        </Box>
    );
}